"use client";

import Image from "next/image";
import Link from "next/link";

import type { AssetStoryblok } from "@/component-types-sb";

type ExpertMiniCardProps = {
  name: string;
  title?: string;
  image?: AssetStoryblok;
  href?: string;
  onPreviewClick?: () => void;
};

const ExpertMiniCard = ({ name, title, image, href, onPreviewClick }: ExpertMiniCardProps) => {
  const card = (
    <div className="card-rotate relative aspect-[3/4] w-[160px] md:w-[199px] rounded-2xl overflow-hidden shrink-0">
      {/* Background Image */}
      {image?.filename && (
        <Image
          src={image.filename}
          alt={image.alt || name || "Expert"}
          fill
          sizes="(max-width: 768px) 160px, 199px"
          className="object-cover"
        />
      )}

      {/* Gradient Overlay */}
      <div className="absolute inset-x-0 bottom-0 h-2/3 md:h-1/2 bg-gradient-to-b from-transparent to-black" />

      {/* Content */}
      <div className="absolute top-0  right-0 bottom-0 left-0 flex flex-col items-center justify-end p-4 text-center">
        {name && <p className="text-copy-bold text-white">{name}</p>}
        {title && <p className="text-copy-sm text-white">{title}</p>}
      </div>
    </div>
  );

  if (onPreviewClick) {
    return <div onClick={onPreviewClick} role="button" tabIndex={0} onKeyDown={(e) => e.key === "Enter" && onPreviewClick()} className="cursor-pointer">{card}</div>;
  }

  if (href) {
    return <Link href={href}>{card}</Link>;
  }

  return card;
};

export default ExpertMiniCard;
